import './Stepper.scss';
import { Stepper, Step, StepLabel, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';

type Props = {
  activeStep: number;
  handleActiveStep: (step: number) => void;
};

export const CartStepper = ({ activeStep, handleActiveStep }: Props) => {
  return (
    <Stepper className='cart-stepper' activeStep={activeStep} alternativeLabel connector={<StepConnector />}>
      <Step disabled={activeStep === 2}>
        <StepLabel StepIconComponent={StepIcon}>Cart</StepLabel>
      </Step>
      <Step disabled={activeStep === 0 || activeStep === 2}>
        <StepLabel StepIconComponent={StepIcon}>Payment</StepLabel>
      </Step>
      <Step disabled={activeStep < 2}>
        <StepLabel StepIconComponent={StepIcon}>Confirmation</StepLabel>
      </Step>
    </Stepper>
  );
};

const StepIcon = (stepIconProps: StepIconProps) => {
  return <div className='stepper-icon'>{stepIconProps.icon}</div>;
};
